import { useKeyboardShortcut } from '@databases/react';
import { defaultStoreUtils } from '@databases/redux';
import { selectSelectedValuesCount } from '@databases/redux/cellSelections/selectors';
import { doClearValues } from '@databases/redux/contextual-menu/actions';
import { useCallback } from 'react';

import { CLEAR_SHORTCUT } from '../shortcuts';

interface ClearValuesKeyboardShortcutProps {
  contentId: string;
  canEditContent: boolean;
}

const useClearValuesKeyboardShortcut = ({
  contentId,
  canEditContent,
}: ClearValuesKeyboardShortcutProps) => {
  const dispatch = defaultStoreUtils.useDispatch();
  const selectedValuesCount = defaultStoreUtils.useSelector((state) =>
    selectSelectedValuesCount(state, { contentId })
  );

  const handleClearValues = useCallback(() => {
    if (canEditContent) {
      dispatch(doClearValues(contentId));
    }
  }, [canEditContent, contentId, dispatch]);

  // Don't register the shortcut when editing single cell value
  useKeyboardShortcut(selectedValuesCount > 1 ? CLEAR_SHORTCUT : undefined, () =>
    handleClearValues()
  );
};

export default useClearValuesKeyboardShortcut;
